import React, { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import InputField from "../inputComponents/InputField";
import Message from "../inputComponents/Message";
import Loading from "../../childComponents/appComponents/Loading";

const ModalFaq = (props) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const BUTTON_NAME = "POST FAQ"; // Submit Button Name
  const [message, setMessage] = useState("");
  const [actionType, setActionType] = useState("");
  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };
  
  const [reloadState, setReloadState] = useState({
           btnLoading: props.modalTitle,
           loading: true,
         });

  //Fetches all Form Data
  const [allformData, setAllFormData] = useState({
    input: {
      faq: null,
      faqAns: null,
      status: null,
      creationDate: getTodayDate(), // ✅ default today
    },
    select: {},
  });

  // function extractColumn(arr, column) {
  //   return arr.map((x) => x[column]);
  // }
  // const [options, setOptions] = useState({
  //   name: [],
  // });

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setAllFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  useEffect(() => {
    setAllFormData((prev) => ({
      ...prev,
      input: {
        faq: props.editposts.faq,
        faqAns: props.editposts.faqAns,
        status: props.editposts.status,
        creationDate:
          props.editposts.creationDate || getTodayDate()
            ? new Date(props.editposts.creationDate * 1000)
                .toISOString()
                .split("T")[0]
            : "",
      },
    }));

    setMessage(props.editposts.faqAns);
    setReloadState((prev) => ({
      ...prev,
      btnLoading: props.modalTitle,
      loading: false,
    }));
   
    //(async () => await populateSelectMenu())();
  }, [props.editposts, props.modalTitle, props.faqAns]);

  // const populateSelectMenu = async () => {
  //   try {
  //     await axios.get("sanctum/csrf-cookie");

  //     const responses = await Promise.all([
  //       axios.get(`${BASE_URL}inputname?status[eq]=Active&authority[lt]=2&authority[gt]=0`),
  //     ]);

  //     const [nameData] = responses;

  //     // populate the select menu
  //     const populateSelect = (colume, columeObject, columeName) => {
  //       if (columeObject?.data?.status === 200) {
  //         return setOptions((prev) => ({
  //           ...prev,
  //           [colume]: extractColumn(columeObject.data.allData, columeName),
  //         }));
  //       }
  //     };

  //     populateSelect("name", nameData, "name");
  //   } catch (error) {
  //     swal("Error", "Error fetching Name Data", "error");
  //     console.log("Error fetching Name Data:", error);
  //   }
  // };

  async function submitUpload(event) {
    event.preventDefault();
    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
      loading: true,
    }));

    let urlpost;

    if (props.modalTitle === "POST FAQ") {
      urlpost = `${BASE_URL}faqdata`;
    } else {
      urlpost = `${BASE_URL}faqdata/update`;
    }
    let formData;

    formData = new FormData();
    if (actionType === "post") {
      formData.append("action", "post");
    }
    if (actionType === "copy") {
      formData.append("action", "copy");
    }
    formData.append("faq", allformData.input.faq.toUpperCase());
    //formData.append("faqAns", allformData.input.faqAns);
    formData.append("faqAns", message);
    formData.append(
      "status",
      allformData.input.status ? allformData.input.status : "publish",
    );
    formData.append("creationDate", allformData.input.creationDate);
    formData.append("id", props.editposts.id);

    await axios.get(`sanctum/csrf-cookie`).then((response) => {
      try {
        axios.post(urlpost, formData).then((res) => {
          if (res?.data?.status === 200) {
            swal("Success", res.data.message, "success");
            setReloadState({
              btnLoading: props.modalTitle,
              loading: false,
            });
            props.formCleanners();
            props.setCloseModal(true);
          } else {
            swal("Oops!", res.data.message, "error");
          }
        });
      } catch (error) {
        swal("Oops!", "Failed", "error");
        console.log(error.response.data);
      }
    });
  }
if (reloadState.loading) {
    return <Loading message01={"Loading..."} />;
  }
  return (
    <>
      <form onSubmit={submitUpload} encType="multipart/form-data">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div
                className={`card-header text-white bg-${props.btnColors} p-3`}
              >
                <i className="fa fa-newspaper"></i> {props.modalTitle}
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <InputField
                    label="FAQ Question"
                    name="faq"
                    size="6"
                    placeholder="Please Type in a Question"
                    required="required"
                    value={allformData.input.faq}
                    type="text"
                    onChange={updateFormData}
                    icon="fa fa-file-text"
                  />

                  <InputField
                    label="Start Date"
                    name="creationDate"
                    size="3"
                    placeholder="Please Select Start Date"
                    required="required"
                    value={allformData.input.creationDate}
                    type="date"
                    onChange={updateFormData}
                    icon="fa fa-calendar-check-o"
                  />

                  <div className="col-lg-3 p-4 row">
                    <InputField
                      label="Save As Draft"
                      size="8"
                      name="status"
                      type="checkbox"
                      checked={allformData.input.status === "draft"}
                      value="draft"
                      onChange={updateFormData}
                    />

                    <InputField
                      label="Publish"
                      size="4"
                      name="status"
                      type="checkbox"
                      checked={allformData.input.status === "publish"}
                      value="publish"
                      onChange={updateFormData}
                    />
                  </div>

                  <Message
                    titles="Message"
                    nameId="message"
                    placeholder="Publication/ Description"
                    size="9"
                    inputState=""
                    moreDetail={message}
                    setMessage={setMessage}
                  />

                  {/* <TextAreaField
                    label="FAQ Answer"
                    name="faqAns"
                    size="6"
                    placeholder="Please Type in a Response"
                    required="required"
                    value={allformData.input.faqAns}
                    rows="6"
                    onChange={updateFormData}
                    icon="fa fa-file-text"
                  /> */}
                  <div className="row m-1">
                    <div className="col-lg-3 ps-4">
                      <div className="form-group mt-2">
                        <button
                          className={`btn btn-${props.btnColors} col-lg-12 mt-4`}
                          onClick={() => setActionType("post")}
                        >
                          <div className="d-flex align-items-center justify-content-center w-100">
                            <i className="fa fa-edit m-1"></i>
                            <span>{reloadState.btnLoading}</span>
                          </div>
                        </button>
                      </div>
                    </div>

                    <div className="col-lg-3 ps-4">
                      <div className="form-group mt-2">
                        <button
                          className={`btn btn-secondary col-lg-12 mt-4`}
                          onClick={() => setActionType("copy")}
                        >
                          <div className="d-flex align-items-center justify-content-center w-100">
                            <i className="fa fa-clone m-1"></i>
                            <span>COPY POST</span>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};
export default ModalFaq;
